import React from 'react';
import { ExtendedTheme, TextBlock } from 'neon-design-system';
import { Box, createStyles, Grid, makeStyles, Paper } from '@material-ui/core';

interface StatCardsProps {
	items: StatCardProps[];
}

interface StatCardProps {
	label: string;
	value: string | number;
}

const useStyles = makeStyles((theme: ExtendedTheme) => createStyles({
	panelDetails: {
		padding: theme.spacing(3)
	},
	panelHeading: {
		fontWeight: 'bold',
		color: theme.palette.grey[400],
		marginBottom: theme.spacing(0.5)
	}
}));

const StatCards = (props: StatCardsProps) => {
	const classes = useStyles();
	const { items = [] } = props;

	return (
		<Grid container spacing={2} justifyContent="space-between">
			{
				items.map((i, index) => (
					<Grid item key={index} style={{ flexGrow: 1 }}>
						<Paper>
							<Box className={classes.panelDetails}>
								<TextBlock styleName="caption1" className={classes.panelHeading}>{i.label}</TextBlock>
								<TextBlock styleName="largeBody1" >{i.value}</TextBlock>
							</Box>
						</Paper>
					</Grid>
				))
			}
		</Grid>
	);
};

export default StatCards;
